import React, { useState } from "react";
import axios from "axios";
import { SearchIcon, SignOutIcon, ToggleIcon, defaultLogo } from "../../Assets/Icons";
import UnoAppsPopover from "../Popover/UnoAppsPopover";
import ThemeSwitchButton from "../Buttons/ThemeSwitchButton";
import { useUnoSelector } from "../../Provider/Provider";

const Header = ({
  searchProps,
  appLogo = null,
  showSearch = true,
  showDrawer = true,
  showThemeSwitch = false,
  userDetails = {},
  appName = "",
  hideSidebar,
  showHamburger = false,
  logoutHandler,
  profileLinks = [],
  logoAndNameClick = () => {},
  headerMenuItems,
  headerBtnTxt,
  onHeaderButtonClick = () => {},
  hideUserDetail = false,
}) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false); // Add state for sidebar visibility
  const { user, token } = useUnoSelector((state) => state?.user);
  const applicationData = useUnoSelector((state) => state?.application);
  const configData = useUnoSelector((state) => state?.config);
  const [active, setActive] = useState(null);
  const { email, name, designation, image } = userDetails;
  const placeholderUserName = (user?.name || name)
    ?.split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

  const appDrawerData = applicationData?.apps?.filter((item) => item.uuid !== applicationData?.currentApplicationId);

  const logOut = async () => {
    if (logoutHandler) {
      logoutHandler();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      if (configData?.config?.UNO_URL) {
        await axios.post(
          `${configData?.config?.UNO_URL}/api/auth/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        window.location.href = `${configData?.config?.redirectUri}`;
        if (logoutHandler) logoutHandler();
      }
    }
  };

  const redirectApplication = (e) => {
    if (e.origin) {
      window.location.href = e.origin;
    }
  };

  const OnToggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
    if (hideSidebar) {
      hideSidebar();
    }
  };

  const onLogoClick = () => {
    if (logoAndNameClick) {
      logoAndNameClick();
    }
  };

  return (
    <header className="main-head">
      <div className="left">
        {showHamburger && (
          <button className="hamburgertoggle" onClick={OnToggleSidebar}>
            <ToggleIcon />
          </button>
        )}

        <span className="logo">
          <img
            onClick={onLogoClick}
            src={configData?.config?.logo || appLogo || defaultLogo}
            referrerPolicy={"no-referrer"}
          />
          <p onClick={onLogoClick}>{configData?.config?.name || appName || ""}</p>
        </span>

        {headerMenuItems && (
          <ul className="headermenulist">
            {headerMenuItems.map((item) => (
              <li
                key={item.key}
                className={active === item.key ? "active" : ""}
                onClick={() => {
                  setActive(item.key);
                  item.clickHandler?.();
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="right ">
        {showSearch && (
          <div className="main-search">
            <span className="search-icon">
              <SearchIcon />
            </span>
            <input type="text" className="form-control" autoComplete="off" {...searchProps} />
          </div>
        )}

        {headerBtnTxt && (
          <button className="headerbutton" onClick={onHeaderButtonClick}>
            {headerBtnTxt}
          </button>
        )}
        {!hideUserDetail && (
          <div className="dropdown">
            <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <span className="name-email">
                <h6>{user?.name || name}</h6>
                <p>{user?.designation || designation}</p>
              </span>
              {user?.avatar || image ? (
                <img src={user?.avatar || image} referrerPolicy={"no-referrer"} />
              ) : (
                <span className="placeholder"> {placeholderUserName} </span>
              )}
            </div>
            <div className="dropdown-menu profile-detail-parent p-0">
              <div className="profile-detail">
                <div className="bg">
                  {user?.avatar || image ? (
                    <img src={user?.avatar || image} referrerPolicy={"no-referrer"} />
                  ) : (
                    <span> {placeholderUserName} </span>
                  )}
                </div>
                <span className="name-email">
                  <p>{user?.name || name}</p>
                  <p className="email">{user?.email || email}</p>
                  <p className="designation">{user?.designation || designation}</p>
                </span>

                {/* Mapping Multiple URLs */}
                {profileLinks.length > 0 && (
                  <div className="profile-links">
                    {profileLinks.map((link, index) => (
                      <p style={{ cursor: "pointer" }} key={index} onClick={link.handleManageProfileClick}>
                        {link.label}
                      </p>
                    ))}
                  </div>
                )}

                <span className="signout" onClick={logOut}>
                  <SignOutIcon />
                  Sign Out
                </span>
              </div>
            </div>
          </div>
        )}
        {showThemeSwitch && <ThemeSwitchButton />}

        {showDrawer && <UnoAppsPopover applications={appDrawerData} onAppClick={redirectApplication} />}
      </div>
    </header>
  );
};

export default Header;
